import React from 'react';
import { DiamondBulletIcon } from './Icons';
import { trackAddToCart } from '../lib/metaPixel';
export const FinalCTA = () => {
  const handleCheckoutClick = () => {
    trackAddToCart({
      content_name: 'The Hormonal Balance Code — Main CTA'
    });
  };
  return <section className="w-full bg-gradient-to-br from-medium to-primary py-10 md:py-14 px-4 md:px-10 flex flex-col items-center text-center" data-id="element-59">
      <h2 className="font-playfair text-[28px] md:text-[46px] text-white mb-3" data-id="element-60">
        You do not need to fight your body anymore.
      </h2>

      <h3 className="font-playfair italic text-[20px] md:text-[28px] text-accent mb-8" data-id="element-61">
        Your body has been trying to protect you — not punish you.
      </h3>

      <a href="https://vitalyforms.com/cart/50255656976604:1" target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="inline-block w-full md:w-auto min-w-0 md:min-w-[320px] bg-white text-medium font-lato font-bold text-[16px] md:text-[18px] uppercase py-[20px] px-[36px] md:px-[48px] rounded-[50px] shadow-[0_8px_24px_rgba(0,0,0,0.2)] hover:bg-light transition-colors duration-300 mb-6 text-center no-underline" data-id="element-62">
        BEGIN YOUR RESET — $27
      </a>

      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 font-lato text-[13px] text-white" data-id="element-63">
        <span data-id="element-64">Instant Access</span>
        <DiamondBulletIcon color="#E0BBE4" size={8} data-id="element-65" />
        <span data-id="element-66">3 Companion Guides Included</span>
        <DiamondBulletIcon color="#E0BBE4" size={8} data-id="element-67" />
        <span data-id="element-68">30-Day Guarantee</span>
      </div>
    </section>;
};